import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertGuestRideSmsMessageMutationVariables = Types.Exact<{
  guestride_id?: Types.InputMaybe<Types.Scalars['bigint']['input']>;
  recipient_phone: Types.Scalars['String']['input'];
  sender_phone: Types.Scalars['String']['input'];
  message_body: Types.Scalars['String']['input'];
  direction: Types.Scalars['String']['input'];
  status: Types.Scalars['String']['input'];
  createdby?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type InsertGuestRideSmsMessageMutation = { __typename?: 'mutation_root', insert_smsmessages_one?: { __typename?: 'smsmessages', id: number, guestride_id?: number | null, recipient_phone?: string | null, sender_phone?: string | null, message_body?: string | null, createdat?: string | null, updatedat?: string | null, status?: string | null, direction: string, createdby?: string | null } | null };


export const InsertGuestRideSmsMessageDocument = gql`
    mutation InsertGuestRideSmsMessage($guestride_id: bigint, $recipient_phone: String!, $sender_phone: String!, $message_body: String!, $direction: String!, $status: String!, $createdby: String) {
  insert_smsmessages_one(
    object: {guestride_id: $guestride_id, recipient_phone: $recipient_phone, sender_phone: $sender_phone, message_body: $message_body, direction: $direction, status: $status, createdby: $createdby}
  ) {
    id
    guestride_id
    recipient_phone
    sender_phone
    message_body
    createdat
    updatedat
    status
    direction
    createdby
  }
}
    `;
export type InsertGuestRideSmsMessageMutationFn = Apollo.MutationFunction<InsertGuestRideSmsMessageMutation, InsertGuestRideSmsMessageMutationVariables>;

/**
 * __useInsertGuestRideSmsMessageMutation__
 *
 * To run a mutation, you first call `useInsertGuestRideSmsMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertGuestRideSmsMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGuestRideSmsMessageMutation, { data, loading, error }] = useInsertGuestRideSmsMessageMutation({
 *   variables: {
 *      guestride_id: // value for 'guestride_id'
 *      recipient_phone: // value for 'recipient_phone'
 *      sender_phone: // value for 'sender_phone'
 *      message_body: // value for 'message_body'
 *      direction: // value for 'direction'
 *      status: // value for 'status'
 *      createdby: // value for 'createdby'
 *   },
 * });
 */
export function useInsertGuestRideSmsMessageMutation(baseOptions?: Apollo.MutationHookOptions<InsertGuestRideSmsMessageMutation, InsertGuestRideSmsMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertGuestRideSmsMessageMutation, InsertGuestRideSmsMessageMutationVariables>(InsertGuestRideSmsMessageDocument, options);
      }
export type InsertGuestRideSmsMessageMutationHookResult = ReturnType<typeof useInsertGuestRideSmsMessageMutation>;
export type InsertGuestRideSmsMessageMutationResult = Apollo.MutationResult<InsertGuestRideSmsMessageMutation>;
export type InsertGuestRideSmsMessageMutationOptions = Apollo.BaseMutationOptions<InsertGuestRideSmsMessageMutation, InsertGuestRideSmsMessageMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/guestRides/queries/insertGuestRideSmsMessage.mutation.gql}
 */
export async function insertGuestRideSmsMessage(
  variables: InsertGuestRideSmsMessageMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertGuestRideSmsMessageMutation['insert_smsmessages_one']>
export async function insertGuestRideSmsMessage(
  variables: InsertGuestRideSmsMessageMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertGuestRideSmsMessageMutation>
export async function insertGuestRideSmsMessage(
  variables: InsertGuestRideSmsMessageMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertGuestRideSmsMessageMutation['insert_smsmessages_one'] | InsertGuestRideSmsMessageMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertGuestRideSmsMessageMutation>(
    InsertGuestRideSmsMessageDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_smsmessages_one
}